import { render, staticRenderFns } from "./Bridges.vue?vue&type=template&id=47f4c171&scoped=true"
import script from "./Bridges.vue?vue&type=script&lang=js"
export * from "./Bridges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4c171",
  null
  
)

export default component.exports